module.exports = __webpack_public_path__ + "static/scrilys-124654a5d8b43672136c6417b8c53090.png";